import { DefaultConfig } from '@sentecacommerce-theme/lib'

export const Config: DefaultConfig = {
  apiUrl: 'http://localhost:5000',
  domain: 'www.hippolandbg.com',
  defaultMerchant: 'hippoland-online',
  interfaceKey: 'bg-interface',
  organizationPhone: '02 / 40 484',
  price: {
    locale: 'bg',
  },
  theme: {
    palette: {
      primary: '#111',
      secondary: '#fff',
      hint: '#757575',
      disabled: '#eee',
      dark: '#333',
      grey: '#ccc',
      lightgrey: '#f1f1f1',
      lightergrey: 'rgba(241, 241, 241, 0.2)',
      initialPrice: 'rgba(128, 128, 128, 0.8)',
      danger: '#ef2809',
      greyTitle: '#666',
      yellow: '#FBD638',
      white: '#fff',
      discounted: '#DE5C60',
      // names generated with https://chir.ag/projects/name-that-color
      seaGreen: '#389361',
      panache: '#E9F5E8',
      surfCrest: '#C7E4C6',
      silverTree: '#58B582',
      burntSienna: '#E66152',
      salmon: '#fa8072',
      whisper: '#e6e6e6',
    },
    breakpoints: {
      xs: {
        min: '0',
        max: '575.98px',
      },
      sm: {
        min: '576px',
        max: '767.98px',
      },
      md: {
        min: '768px',
        max: '991.98px',
      },
      lg: {
        min: '992px',
        max: '1199.98px',
      },
      xl: {
        min: '1200px',
        max: '1399.98px',
      },
      xxl: {
        min: '1400px',
      },
    },
    containers: {
      xs: 'auto',
      sm: '125rem',
      md: '125rem',
      lg: '125rem',
      xl: '180rem',
      xxl: '180rem',
    },
    spacingBaseUnit: 1,
    elementsBorderRadius: 2,
    typography: {
      fontFamily: ['Farfetch Basis', 'Helvetica Neue', 'Arial', 'sans-serif'],
    },
  },

  favicon: {
    default:
      'https://production.hippoland-contents.com/platform/media/favicon-5fec77c8c7bfa70018ddf7a8.ico',
  },

  palette: {
    primary: '#111',
    secondary: '#fff',
    hint: '#757575',
    disabled: '#eee',
    dark: '#333',
    grey: '#ccc',
    lightgrey: '#f1f1f1',
    lightergrey: 'rgba(241, 241, 241, 0.2)',
    initialPrice: 'rgba(128, 128, 128, 0.8)',
    danger: '#ef2809',
    greyTitle: '#666',
    yellow: '#FBD638',
    white: '#fff',
    discounted: '#DE5C60',
    // names generated with https://chir.ag/projects/name-that-color
    seaGreen: '#389361',
    panache: '#E9F5E8',
    surfCrest: '#C7E4C6',
    silverTree: '#58B582',
    burntSienna: '#E66152',
    salmon: '#fa8072',
    whisper: '#e6e6e6',
  },
  breakpoints: {
    xs: {
      min: '0',
      max: '575.98px',
    },
    sm: {
      min: '576px',
      max: '767.98px',
    },
    md: {
      min: '768px',
      max: '991.98px',
    },
    lg: {
      min: '992px',
      max: '1199.98px',
    },
    xl: {
      min: '1200px',
      max: '1399.98px',
    },
    xxl: {
      min: '1400px',
    },
  },
  containers: {
    xs: 'auto',
    sm: '125rem',
    md: '125rem',
    lg: '125rem',
    xl: '144rem',
    xxl: '144rem',
  },
  spacingBaseUnit: 1,
  elementsBorderRadius: 2,
  typography: {
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      'Oxygen-Sans',
      'Ubuntu',
      'Cantarell',
      '"Helvetica Neue"',
      'sans-serif',
    ],
  },
  imagesConfig: {
    ratio: {
      width: 1,
      height: 1,
    },
    fallbackImage:
      'https://staging.sportdepot-contents.com/platform/media/placeholder-image-602b9b2cea638c0012e84401.png',
  },

  countryCode: 'BG',

  facebook: {
    appId: '446866882022379',
  },
  google: {
    id:
      '665946581009-cb37q8g2qet1b9remmjhdtebgep88kgo.apps.googleusercontent.com',
    reMarketing: {
      id: '123',
      label: 'AESAEA',
    },
  },

  attributeKeys: {
    color: 'color',
    size: 'sizes',
  },
  freeShippingPrice: 65,
  customFieldKeys: {
    isWithFixedDelivery: 'fixedDelivery',
    isOnlyInPhysicalStores: 'onlyInPhysicalStores',
    isOnlyInHippoland: 'onlyInHippoland',
    isNew: 'isNew',
    isWithVideo: 'hasVideo',
    isAction: 'action',
    isOnlineOnly: 'onlineOnly',
    isWithTopPrice: 'topPrice',
    video: 'video',
    hasVideo: 'hasVideo',
    newToDate: 'newToDate',
    newFromDate: 'newFromDate',
    hideRegularPrice: 'hideRegularPrice',
    hidePromoLabel: 'hidePromoLabel',
    discountIcon: 'discountIcon',
  },
  wallets: {
    hippoWallet: 'hippo',
  },
  views: {
    auth: 'AUTH',
    gdprModal: 'GDPR',
    checkoutBasketPreview: 'CHECKOUT_BASKET_PREVIEW',
    addressForm: 'ADDRESS_FORM',
  },
  courierKeys: {
    econt: 'Econt',
    speedy: 'Speedy',
    evropat: 'Evropat',
  },
  integration: 'https://integration.hippoland-api.com',

  listing: {
    defaultSort: 'default-desc',
    filterExtension: 'integer_field.inventory-hippoland-online;range;1,*',
  },

  inventory: {
    maxQuantity: 3,
  },

  affiliates: {
    twoPerformant: {
      campaignUnique: 'c212fbe1e',
      confirm: 'ade06c9fd7625cd8',
    },
  },

  analytics: {
    facebookPixel: '1387454978246887',
    googleAds: 'AW-776245359',
    googleAnalytics: 'UA-35670487-1',
    googleTagManager: 'GTM-THP29Q4',
  },

  globalLabels: {
    freeDelivery: 'Безплатна доставка!',
    close: 'Затвори',
    cancel: 'Отказ',
    remove: 'Изтрий',
    save: 'Запази',
    edit: 'Редактирай',
    begin: 'Начало',
    apply: 'Приложи',
    show: 'Покажи',
    nr: '№',
    viewAll: 'Виж всички',
    productNumber: 'Продуктов номер',
    offerIsValid: 'Промоцията е валидна',
    sku: 'sku',
    qty: 'Количество',
    onlyInHippoland: 'Само в хиполенд',
    onlyOnline: 'Само онлайн',
    new: 'Ново',
    bestSeller: 'Най-продаван',
    notRegistered: 'Не сте регистрирани?',
    continueAsGuest: 'Продължи като гост',
    send: 'Изпрати',
    logIn: 'Вход',
    enter: 'Влез',
    back: 'Назад',
    or: 'или',
    signs: { minus: '-', percent: '%', hashTag: '#', lessThan: '<' },
    basketPreview: 'Преглед на количката',
    addToWishlist: 'Добави в любими',
    under: 'под',
    over: 'над',
    bgn: 'лв',
    delivery: 'Доставка',
    total: 'Общо',
    continueWithShopping: 'Продължи с пазаруването',
    availableOnlyInPhysicalStores: ' Налично само в някои физически магазини',
    gender: {
      male: 'Мъж',
      female: 'Жена',
    },
    pagination: {
      prevPage: 'Предишна страница',
      nextPage: 'Следваща страница',
    },
    socialLogins: {
      facebook: 'Влез с Facebook',
      google: 'Влез с Google',
    },
    register: {
      label: 'Регистрация',
      callToAction: 'Регистрирай се',
    },
    emailAddress: 'Имейл адрес',
    placeholders: {
      day: 'Ден',
      month: 'Месец',
      year: 'Година',
      email: 'Имейл',
      choose: 'Избери',
      chooseStore: 'Избери магазин',
      newPassword: 'Нова парола',
    },
    password: {
      label: 'Парола',
      forgottenPassword: 'Забравена парола',
      changePassPrompt: {
        initial: 'Ще получите имейл с линк за рестартиране на Вашата парола.',
        final:
          'Въведи твоя имейл адрес, с който си се регистрирал и ще ти изпратим линк, за да си генерираш нова парола.',
      },
      backToLogIn: 'Обратно към вход',
      orReturnTo: 'Или се върни на',
      reEnterPassword: 'Потвърдете паролата',
      changePassword: 'Промяна на парола',
      pleaseEnterNewPassword: 'Моля въведете новата парола',
    },
    toastNotifications: {
      success: {
        subscribe: 'Записахте се успешно',
        unsubscribe: 'Отписахте се успешно',
      },
    },
    buttonLabels: {
      ariaLabel: 'Добави в количка',
      alreadyInBasket: 'Вече е в количката',
      add: 'Добави',
    },
    errorMessages: {
      outOfStock: 'Продуктът не е наличен',
      notEnoughQty: 'Няма достатъчна наличност',
      outOfStockBasket: 'Няма наличност',
      notAvailable: 'Не е наличен',
      noResultsFound: 'Няма намерени резултати',
      somethingWentWrong: 'Нещо се обърка',
      invalidCredentials: 'Невалиден имейл или парола',
      emailIsAlreadyInUse: 'Имейлът е зает',
      pleaseSelectAnOption: 'Моля изберете опция',
    },
    company: {
      companyData: 'Данни за фирмата',
      companyName: 'Име на фирмата',
      mol: 'МОЛ',
      vat: 'ДДС',
      companyId: 'ЕИК',
      saveAsDefault: 'Запази като основна фирма',
    },
    promoCodeLabels: {
      promoCodeBoxTitle: 'Промо код',
      promoCodeDefaultErrorMessage: 'Невалиден код',
      promoCodeSubmitLabel: 'Приложи',
      promoCodeInputPlaceholder: 'Въведете код...',
      errorsMap: {
        MaxApplicationReached: 'Масксималният лимит е достигнат',
        NotValid: 'Невалиден код',
        NotActive: 'Невалиден код',
        DoesNotMatchCart: 'Невалиден код',
        ApplicationStoppedByPreviousDiscount: 'Невалиден код',
      },
    },
    globalValidations: {
      invalidEmail: 'Невалиден имейл',
      invalidNumber: 'Невалиден телефонен номер',
      invalidPhoneNumber: 'Невалиден телефонен номер',
      requiredFields: '* Задължителни полета',
      fieldIsRequired: 'Полето е задължително',
      fillStreetNumberBuildingEntranceOrApartment:
        'Моля попълнете номер на улица, вход, сграда или апартамент.',
      streetIsRequired: 'Въведете име на улица',
      quarterIsRequired: 'Въведете име на квартал',
      emailIsRequired: 'Задължително поле',
      cantFindStreetOrQuarterMessage:
        'Ако не можете да намерите улица или квартал, моля попълнете полето за допълнителна информация',
      cityIsRequired: 'Въведете град',
      inactiveCard: 'Картата е невалидна',
      officeIsRequired: 'Въведете офис',
      selectCourier: 'Изберете куриер',
      noStoreSelected: 'Изберете магазин',
      enterNsymbolsSentence: {
        begin: 'Моля въведете поне',
        end: 'символа',
      },
      passwordsDoNotMatch: 'Паролите не съвпадат',
      passwordLength: 'Паролата трябва да съдържа поне 8 символа',
    },
    couriers: {
      pickACourier: 'Избери куриер',
      couriersList: {
        econtAddress: 'Econt-Address',
        speedyAddress: 'Speedy-Address',
        evropatAddress: 'Evropat-Address',

        econtOffice: 'Econt-Office',
        speedyOffice: 'Speedy-Office',
        evropatOffice: 'Evropat-Office',
      },
    },
    personalInformation: {
      label: 'Лична информация',
      firstName: 'Име',
      lastName: 'Фамилия',
      email: 'Имейл',
      number: 'Телефон',
    },
    address: {
      label: 'Адрес',
      city: 'Град *',
      quarter: 'Квартал *',
      street: 'Улица *',
      streetNumber: 'Улица номер',
      number: 'Номер',
      building: 'Блок номер',
      postalCode: 'Пощ. код',
      entrance: 'Вход',
      floor: 'Етаж',
      et: 'ет.',
      ap: 'ап.',
      vh: 'вх.',
      ul: 'ул.',
      apartment: 'Апартамент',
      additionalInformation: 'Допълнителна информация',
      addNewAddress: 'Добави нов адрес',
      noSavedAddresses: 'Нямате запазени адреси',
      addAddressWarning:
        '* Адреси могат да бъдат добавяни само при завършване на поръчка',
      mainAddress: 'Основен адрес',
      office: 'Офис',
      courier: 'Куриер:',
    },
  },

  SSR: {
    staticPagesRevalidateTime: 60 * 60, // 1h
    blogRevalidateTime: 60 * 120, // 2h
    productRevalidateTime: 60 * 5, // 5m
  },
}
